import { classNames } from "../../../../lib/classNames"
import { LoadingSpinner } from "../../feedback/LoadingSpinner"
import { TextInput, TextInputProps } from "../text/TextInput"

export interface SingleCharacterInputProps
  extends Omit<TextInputProps, "size"> {
  size?: "sm" | "lg"
  isLoading?: boolean
}

export const SingleCharacterInput = ({
  className,
  size = "lg",
  isLoading,
  disabled,
  ref,
  ...otherProps
}: SingleCharacterInputProps) => {
  const cn = classNames(
    "bg-input-bold rounded-lg",
    size === "sm" && "h-10 w-10",
    size === "lg" && "h-20 w-20",
    className
  )

  if (isLoading) {
    return (
      <div
        className={classNames(
          "flex items-center justify-center",
          cn,
          otherProps.containerClassName,
          disabled && "bg-input-disabled"
        )}
      >
        <LoadingSpinner size={size === "sm" ? "small" : "large"} />
      </div>
    )
  }

  return (
    <TextInput
      className={classNames(
        "text-center",
        size === "sm" && "text-title-body",
        size === "lg" && "text-display",
        cn
      )}
      selectOnFocus={false}
      disabled={disabled}
      ref={ref}
      {...otherProps}
    />
  )
}
